import { deleteUserProfileImage } from '@dc-shared-web/hooks/api/user/deleteUserProfileImage'
import { User } from '@dc-shared-web/hooks/api/user/types'
import { useSvcCrunchesContext } from '@dc-shared-web/providers'
import { useMutation, useQueryClient } from 'react-query'

export const useDeleteUserProfileImage = (userId: string) => {
  const svcCrunchesApiClient = useSvcCrunchesContext()
  const queryClient = useQueryClient()

  return useMutation(
    (userId: string) =>
      deleteUserProfileImage(svcCrunchesApiClient, { userId }),
    {
      onSuccess: async () => {
        await queryClient.invalidateQueries<User>(`user-${userId}`)
      },
    }
  )
}
